import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PostInvoicesRecover,
	PostInvoicesRecoverModel,
	PostInvoicesRecoverParams,
} from 'domain/usecases';

export class RemotePostInvoicesRecover implements PostInvoicesRecover {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostInvoicesRecoverModel>,
	) {}

	async post({signal, ...body}: PostInvoicesRecoverParams): Promise<PostInvoicesRecoverModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
